import React from "react";
import cx from "classnames";
import styles from "./ReadMoreBtnEl.module.css";
import Link from "next/link";
import uuid from "react-uuid";
const ReadMoreBtnEl = ({
  href = undefined,
  btnTitle,
  reverceStyle = false,
}) => {
  return (
    <>
      {href ? (
        <Link
          aria-label="read more"
          href={String(href)}
          target="_blank"
          className={cx(
            styles.readmoreBtnStyles,
            reverceStyle && styles.readmoreBtnStylesReverce,
            "d-flex",
            "align-items-center",
            "justify-content-center",
          )}
        >
          {btnTitle}
        </Link>
      ) : (
        <button
          className={cx(
            styles.readmoreBtnStyles,
            reverceStyle && styles.readmoreBtnStylesReverce,
            "d-flex",
            "align-items-center",
            "justify-content-center"
          )}
          id={uuid()}
          aria-label="read more"
        >
          {btnTitle}
        </button>
      )}
    </>
  );
};

export default ReadMoreBtnEl;
